import React from 'react';
import like from '../../../media/images/reaction/like.svg';
import love from '../../../media/images/reaction/love.svg';
import care from '../../../media/images/reaction/care.svg';
import wow from '../../../media/images/reaction/wow.svg';
import haha from '../../../media/images/reaction/haha.svg';
import sad from '../../../media/images/reaction/sad.svg';
import angry from '../../../media/images/reaction/angry.svg';
import ask from '../../../media/images/reaction/ask.svg';
import tick from '../../../media/images/reaction/tick.svg';

export default function MessageEmoji({ msg_id, has_emoji }) {
    return (
        <>
            <div className="msgReactionContainer">
                {has_emoji?.thumbsup > 0 && (
                    <div className="msgReaction pr-1" data-for={'thumbsup_tooltip' + msg_id}>
                        <span role="img" aria-label="thumbsup" className="msgReactionIcon" data-name="thumbsup">
                            <img title='Like' src={like} alt='like' />
                        </span>
                        <span className="msgReactionCounter">{has_emoji?.thumbsup}</span>
                    </div>
                )}
                {has_emoji?.heart > 0 && (
                    <div className="msgReaction pr-1" data-for={'heart_tooltip' + msg_id}>
                        <span role="img" aria-label="heart" className="msgReactionIcon" data-name="heart">
                            <img title='Love' src={love} alt='love' />
                        </span>
                        <span className="msgReactionCounter">{has_emoji?.heart}</span>
                    </div>
                )}
                {has_emoji?.joy > 0 && (
                    <div className="msgReaction pr-1" data-for={'joy_tooltip' + msg_id}>
                        <span role="img" aria-label="joy" className="msgReactionIcon" data-name="joy">
                            <img title='Care' src={care} alt='care' />
                        </span>
                        <span className="msgReactionCounter">{has_emoji?.joy}</span>
                    </div>
                )}
                {has_emoji?.open_mouth > 0 && (
                    <div className="msgReaction pr-1" data-for={'open_mouth_tooltip' + msg_id}>
                        <span role="img" aria-label="open_mouth" className="msgReactionIcon" data-name="open_mouth">
                            <img title='Wow' src={wow} alt='wow' />
                        </span>
                        <span className="msgReactionCounter">{has_emoji?.open_mouth}</span>
                    </div>
                )}
                {has_emoji?.grinning > 0 && (
                    <div className="msgReaction pr-1" data-for={'grinning_tooltip' + msg_id}>
                        <span role="img" aria-label="grinning" className="msgReactionIcon" data-name="grinning">
                            <img title='Haha' src={haha} alt='haha' />
                        </span>
                        <span className="msgReactionCounter">{has_emoji?.grinning}</span>
                    </div>
                )}
                {has_emoji?.disappointed_relieved > 0 && (
                    <div className="msgReaction pr-1" data-for={'disappointed_relieved_tooltip' + msg_id}>
                        <span role="img" aria-label="disappointed_relieved" className="msgReactionIcon" data-name="disappointed_relieved">
                            <img title='Sad' src={sad} alt='sad' />
                        </span>
                        <span className="msgReactionCounter">{has_emoji?.disappointed_relieved}</span>
                    </div>
                )}
                {has_emoji?.rage > 0 && (
                    <div className="msgReaction pr-1" data-for={'rage_tooltip' + msg_id}>
                        <span role="img" aria-label="rage" className="msgReactionIcon" data-name="rage">
                            <img title='Angry' src={angry} alt='angry' />
                        </span>
                        <span className="msgReactionCounter">{has_emoji?.rage}</span>
                    </div>
                )}
                {has_emoji?.folded_hands > 0 && (
                    <div className="msgReaction pr-1" data-for={'folded_hands_tooltip' + msg_id}>
                        <span role="img" aria-label="folded_hands" className="msgReactionIcon" data-name="folded_hands">
                            <img title='Ask' src={ask} alt='ask' />
                        </span>
                        <span className="msgReactionCounter">{has_emoji?.folded_hands}</span>
                    </div>
                )}
                {has_emoji?.check_mark > 0 && (
                    <div className="msgReaction pr-1" data-for={'check_mark_tooltip' + msg_id}>
                        <span role="img" aria-label="check_mark" className="msgReactionIcon" data-name="check_mark">
                            <img title='Tick' src={tick} alt='tick' />
                        </span>
                        <span className="msgReactionCounter">{has_emoji?.check_mark}</span>
                    </div>
                )}
            </div>
        </>
    );
}
